import React, { Component } from "react";
import QrReader from "react-qr-reader-es6";
import { Button, Typography, Snackbar, Alert } from "@mui/material";

class CheckOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: "",
      open: false,
      alreadyCheckedOut: false,
      damaged: false, // Track if item is damaged
    };
  }

  handleScan = (data) => {
    if (data) {
      this.setState({
        result: data,
      });
    }
  };

  handleError = (err) => {
    console.error(err);
  };

  // Function to update the atWarehouse status in the database
  updateEquipmentStatus = async (equipmentId) => {
    try {
      const response = await fetch(
        `https://k0uhot18c2.execute-api.us-east-1.amazonaws.com/staging/equipments/${equipmentId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ atWarehouse: false }), // Set atWarehouse to false for checkout
        }
      );
      if (!response.ok) {
        throw new Error("Failed to update equipment status");
      }
      console.log("Equipment status updated successfully");
    } catch (error) {
      console.error("Error updating equipment status:", error);
    }
  };

  handleClick = async () => {
    const { result } = this.state;
    if (result) {
      try {
        const getResponse = await fetch(
          `https://k0uhot18c2.execute-api.us-east-1.amazonaws.com/staging/equipments/${result}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (!getResponse.ok) {
          throw new Error("Failed to fetch equipment data");
        }

        const equipmentData = await getResponse.json();
        console.log("Full equipment data response:", equipmentData);

        // Check if the equipment is damaged
        if (equipmentData[0]?.Damaged === true) {
          this.setState({
            open: true,
            damaged: true,
            alreadyCheckedOut: false,
          });
        } else if (equipmentData[0]?.atWarehouse === false) {
          // Check if the equipment is already checked out
          this.setState({
            open: true,
            alreadyCheckedOut: true,
            damaged: false,
          });
        } else {
          // Proceed with checkout only if the item is neither damaged nor already checked out
          await this.updateEquipmentStatus(result);
          this.setState({
            open: true,
            alreadyCheckedOut: false,
            damaged: false,
          });
        }
      } catch (error) {
        console.error("Error fetching equipment data:", error);
      }
    }
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ open: false });
  };

  render() {
    return (
      <div align="center">
        <Typography
          align="center"
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, m: 2 }}
        >
          Check Out Equipment
        </Typography>

        <QrReader
          delay={1000}
          onError={this.handleError}
          onScan={this.handleScan}
          style={{ width: "70%" }}
          constraints={{
            facingMode: "environment",
          }}
        />

        <p>Equipment ID: {this.state.result}</p>

        <Button
          variant="contained"
          onClick={this.handleClick}
          disabled={!this.state.result} // Disable button if no item is scanned
        >
          Check Out
        </Button>

        <Snackbar
          open={this.state.open}
          autoHideDuration={10000}
          onClose={this.handleClose}
        >
          {this.state.damaged ? (
            <Alert onClose={this.handleClose} severity="error" sx={{ width: "100%" }}>
              Item {this.state.result} cannot be checked out. It is marked as damaged.
            </Alert>
          ) : this.state.alreadyCheckedOut ? (
            <Alert onClose={this.handleClose} severity="error" sx={{ width: "100%" }}>
              Item {this.state.result} is already checked out.
            </Alert>
          ) : (
            <Alert onClose={this.handleClose} severity="success" sx={{ width: "100%" }}>
              Item {this.state.result} is checked out.
            </Alert>
          )}
        </Snackbar>
      </div>
    );
  }
}

export default CheckOut;
